export default __webpack_public_path__ + "static/media/close_white.a14fa94d.svg";